export * from './dashboard-view.component';


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/views/dashboard-view/index.ts